import React, { useState, useEffect } from 'react';
import { LifeCycles } from 'single-spa';
import Parcel from 'single-spa-react/parcel';
import { useIsDestroyed } from '@landr/maestro';
import { importBillingMfe } from 'utils/externalImports';

interface UpsellPricingRadioCardsParcelProps {
    allowedFeatureUpsell: string;
    selectedPlan?: string;
    onPlanChange?: (plan: string | undefined, isYearly: boolean) => void;
}

export const UpsellPricingRadioCardsParcel: React.FC<
    UpsellPricingRadioCardsParcelProps
> = (props) => {
    const [upsellPricingRadioCardsConfig, setUpsellPricingRadioCardsConfig] =
        useState<LifeCycles<Record<string, unknown>> | null>(null);

    const isDestroyed = useIsDestroyed();

    useEffect(() => {
        importBillingMfe()
            .then((module) => module.loadUpsellPricingRadioCardsParcel())
            .then((basicParcel) => {
                if (isDestroyed.current) {
                    return;
                }
                setUpsellPricingRadioCardsConfig(basicParcel);
            });
    }, [isDestroyed]);

    if (!upsellPricingRadioCardsConfig) {
        return null;
    }

    return <Parcel config={upsellPricingRadioCardsConfig} {...props} />;
};
